import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/job-positions/new/loading';

export const Route = createFileRoute('/_private/settings/job-positions/new')({
  pendingComponent: Loading,
});
